import { render } from "./squade-container.vue?vue&type=template&id=fe444c5a&scoped=true&ts=true"
import script from "./squade-container.vue?vue&type=script&lang=ts"
export * from "./squade-container.vue?vue&type=script&lang=ts"

import "./squade-container.vue?vue&type=style&index=0&id=fe444c5a&scoped=true&lang=scss"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe444c5a"]])

export default __exports__